import React, { ChangeEvent, FC, forwardRef, InputHTMLAttributes } from 'react';

type ColorInputProps = InputHTMLAttributes<HTMLInputElement> & {
  color?: string;
  changeColor?: (color: string) => void;
  label?: string;
};

const ColorInput: FC<ColorInputProps> = forwardRef<HTMLInputElement, ColorInputProps>(
  (props, forwardedRef) => {
    const { color = '#c592f7', changeColor, label, onChange, ...rest } = props;

    function handleChangeColor(event: ChangeEvent<HTMLInputElement>) {
      changeColor?.(event.target.value);
      onChange?.(event);
    }

    return (
      <label className="inline-flex items-center cursor-pointer">
        <div
          className={`rounded-full ${
            ['#FFFFFF', '#FFF', '#fff', '#ffffff'].includes(color)
              ? 'border-0color border border-solid'
              : ''
          } w-[22px] h-[22px] active:scale-[95%] overflow-hidden`}
        >
          <input
            ref={forwardedRef}
            className="rounded-full w-[50px] h-[50px] mt-[-10px] ml-[-10px] cursor-pointer border-0"
            type="color"
            value={color}
            onChange={handleChangeColor}
            {...rest}
          />
        </div>

        {label && <div className="ml-[12px] text-[15px] font-[500]">{label}</div>}
      </label>
    );
  },
);

ColorInput.displayName = 'ColorInput';

export default ColorInput;
